import styled, { css } from 'styled-components';
import ThemedTooltip from '../../theme/ThemedTooltip';
import { ReactComponent as Crown } from '../../assets/img/crown.svg';
import { ReactComponent as StyledLeftArrowIcon } from '../../assets/img/go-arrow-left.svg';
import { fontDisplay, fontUi, pill } from '../../theme/typography';

export const StyledReactTooltip = styled(ThemedTooltip)`
  box-shadow: 0 0 15px 5px rgba(17, 17, 17, 0.08);
  font-family: Archivo;
  cursor: pointer;
  border: 1px solid ${({ theme }) => theme.border};
  background: ${({ theme }) => theme.card};
  max-width: 190px;
  white-space: normal;
  text-transform: none;
  text-align: center;
  &.__react_component_tooltip.show {
    color: ${({ theme }) => theme.text};
    font-size: 13px;
    line-height: 18px;
    border-radius: 6px;
    opacity: 1;
  }
`;
export const StyledPagination = styled.section`
  margin: 10px 0;
`;

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  border-style: hidden;
`;

export const StyledThead = styled.thead`
  border-bottom: 1px solid ${({ theme }) => theme.borderSubtle};
  ${({ display }) => {
    if (display === 'none')
      return css`
        display: none;
      `;
  }}
`;

export const StyledTbody = styled.tbody`
  /* border-top: 12px solid #e5e5e5; */
  &::before {
    content: '';
    display: block;
    height: 0px;
  }
`;

export const StyledTrTh = styled.tr``;

export const StyledTh = styled.th`
  padding: 6px 0 6px;
  background: transparent;
  font-family: 'Archivo', sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 26px;
  letter-spacing: 0.04em;
  color: ${({ theme }) => theme.textFaint};
  &[type='POS'] {
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.04em;
    color: ${({ theme }) => theme.textFaint};
    text-align: center;
    width: 36px;
  }
  @media screen and (max-width: 426px) {
    ${({ type }) => {
      if (type === 'W' || type === 'L' || type === 'D' || type === 'GD') {
        return css`
          // display: none;
        `;
      }
    }}
  }

  /* @media screen and (max-width: 425px) {
    padding: 0;
  } */
  &:first-of-type {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 0px;
  }
  &:last-of-type {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 0px;
  }
  ${({ display, titleNumberName, type }) => {
    if (titleNumberName)
      return css`
        display: none;
      `;
    if (display === 'none')
      return css`
        display: none;
      `;
    if (type === 'Number') {
      return css`
        width: 5%;
        min-width: 50px;
      `;
    }
    if (type === 'Name') {
      return css`
        width: 15%;
        min-width: 105px;
      `;
    }
    if (type === 'Team') {
      return css`
        text-align: left;
      `;
    }
    if (type === 'W') {
      return css`
        @media screen and(max-width:425px) {
          //   display: none;
        }
      `;
    }
    if (type === 'L') {
      return css`
        @media screen and(max-width:425px) {
          // display: none;
        }
      `;
    }
    if (type === 'GD') {
      return css`
        @media screen and(max-width:425px) {
          // display: none;
        }
      `;
    }
    if (type === 'GF' || type === 'GA') {
      return css`
        width: 40px;
        @media screen and (max-width: 768px) {
          display: none;
        }
      `;
    }
  }}
`;

export const StyledTrTd = styled.tr`
  border-bottom: 1px solid ${({ theme }) => theme.borderSubtle};
  background: transparent;
  position: relative;
  &:hover {
    cursor: pointer;
    background: ${({ theme }) => theme.hover};
  }
  td:first-of-type {
    position: relative;
    ${({ $zone }) => {
      const color =
        $zone === 'champion'
          ? '#fdca40'
          : $zone === 'promotion'
            ? '#00b56a'
            : $zone === 'relegation'
              ? '#e94235'
              : null;
      if (!color) return '';
      return css`
        &:before {
          position: absolute;
          left: 0;
          top: 0;
          content: '';
          width: 4px;
          height: 100%;
          background: ${color};
        }
      `;
    }}
  }
  ${({ currentRate, theme }) => {
    if (currentRate) {
      const fill = theme.isDark
        ? 'rgba(14, 74, 251, 0.24)'
        : 'rgba(14, 74, 251, 0.12)';
      const fillHover = theme.isDark
        ? 'rgba(14, 74, 251, 0.32)'
        : 'rgba(14, 74, 251, 0.18)';
      return css`
        background: ${fill};
        &:hover {
          background: ${fillHover};
        }
      `;
    }
  }}
  &:last-of-type {
    border-bottom: 0;
  }
`;

export const StyledTd = styled.td`
  text-align: center;
  padding: 8px 0px;
  font-family: 'Archivo', sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  color: ${({ theme }) => theme.text};
  width: 100px;
  /* background: white; */
  /* @media screen and (max-width: 425px) {
    padding: 0;
  } */
  @media screen and (max-width: 768px) {
    font-size: 12px;
  }
  ${({ titleCell, type }) => {
    if (titleCell)
      return css`
        text-align: left;
      `;
    if (type === 'PTS') {
      return css`
        ${fontDisplay};
      `;
    }
    if (type === 'D') {
      return css`
        ${fontUi};
        font-weight: 400;
      `;
    }
    if (type === 'GD') {
      return css`
        ${fontUi};
        font-weight: 400;
        padding-right: 10px;
      `;
    }
    if (type === 'GF' || type === 'GA') {
      return css`
        ${fontUi};
        font-weight: 400;
        width: 40px;
        @media screen and (max-width: 768px) {
          display: none;
        }
      `;
    }
    if (type === 'L') {
      return css`
        ${fontUi};
        font-weight: 400;
        padding-right: 6px;
      `;
    }
    if (type === 'W') {
      return css`
        ${fontUi};
        font-weight: 400;
        padding-left: 3px;
      `;
    }
    if (type === 'NO' || type === 'POS') {
      return css`
        width: 40px;
        opacity: 1;
        color: ${({ theme }) => theme.textMuted};
        padding-left: 10px;
      `;
    }
    if (type === 'Team') {
      return css`
        ${fontUi};
        font-weight: 400;
        text-align: left;
        width: inherit;
        white-space: nowrap;
        display: flex;
        align-items: center;
        img {
          width: 18px;
          margin-bottom: -4px;
          margin-left: 5px;
        }
        img.team-crest {
          width: 18px;
          height: 18px;
          object-fit: contain;
          margin: 0 8px 0 0;
          flex-shrink: 0;
        }
      `;
    }
  }}
`;

export const StyledLabel = styled.span`
  ${pill};
  margin-left: 5px;
  padding: 3px 8px;
  font-size: 9px;
  letter-spacing: 0.06em;
  color: ${({ theme }) => (theme.isDark ? '#dbe4ff' : '#3d4e8c')};
  text-transform: uppercase;
  background-color: ${({ theme }) => (theme.isDark ? 'rgba(114, 137, 218, 0.28)' : '#dce3f8')};
  @media only screen and (max-width: 768px) {
    font-size: 8px;
    padding: 3px 6px;
  }
`;

export const StyledCrown = styled(Crown)`
  margin-left: 5px;
`;
export const StyledTitle = styled.h3`
  margin-left: 15px;
  height: 46px;
  background-color: ${({ theme }) => theme.card};
  color: ${({ theme }) => theme.text};
  font-size: 15px;
  font-weight: bold;
  display: flex;
  align-items: center;
  flex-direction: row;
  @media only screen and (max-width: 991px) {
    margin-left: 0px;
    padding-left: 15px;
    background-color: transparent;
  }
  svg {
    margin-right: 20px;
  }
`;

export const StyledLeftArrow = styled(StyledLeftArrowIcon)``;
export const StyledMobileSidebar = styled.div`
  background: ${({ customBg, theme }) => customBg || theme.page};
  height: 100%;
  width: 100%;
  position: fixed;
  margin-left: -100%;
  z-index: 11;
  top: 45px;
  left: 0px;
  padding-top: 0px;
  transition: all 0.2s ease 0s;
  overflow: auto;
  padding-bottom: 10px !important;
  ${({ isOpened }) => {
    if (isOpened) {
      return css`
        width: 100%;
        margin-left: 0;
      `;
    }
  }}
  ${({ isOpened }) => {
    if (isOpened) {
      return css`
        width: 100%;
      `;
    }
  }}
`;
